import React from 'react';
import { CTAButton } from './CTAButton';
import { BoxImage } from './BoxImage';
export function FinalCTA() {
  return <section className="border-t-4 border-aqua bg-navy text-center" data-id="element-50" data-mp="3udf8az5tp7i7">
      <div className="px-3 py-4 sm:px-6" data-id="element-51" data-mp="c7adq4y3g6gj">
        <div className="mx-auto max-w-xl" data-id="element-52" data-mp="c8c0h6oh2he3">
          <h2 className="font-display text-[1.55rem] font-extrabold uppercase leading-none text-white sm:text-[2.1rem]" data-id="element-53" data-mp="8573tkr2p9xd">
            ONE LAST <span className="text-aqua" data-id="element-54" data-mp="m3wx0parupgg">QUESTION</span>
          </h2>
          <p className="mt-1.5 text-[0.8rem] leading-[1.4] text-white/85 sm:text-[0.92rem]" data-id="element-55" data-mp="h6569ylv59du">
            When you arrive at a pool or spa with a malfunctioning pump, poor circulation, a heater that
            won't start, a filtration problem or an equipment warning...
          </p>
          <p className="mt-1 font-display text-[1.02rem] font-extrabold uppercase leading-tight text-sun sm:text-[1.3rem]" data-id="element-56" data-mp="qy17hij8xfma">
            Do you know exactly what to inspect, how to isolate the fault and what to check next?
          </p>
          <p className="mt-1 text-[0.8rem] leading-[1.4] text-white/85 sm:text-[0.92rem]" data-id="element-57" data-mp="2c5g7m9or38xj">
            Stop relying on guesswork, scattered manuals and disconnected notes to troubleshoot pool and
            spa equipment.
          </p>
          <p className="mt-1 font-display text-[0.74rem] font-extrabold uppercase text-aqua sm:text-[0.88rem]" data-id="element-58" data-mp="2m1j5v4ghenf7">
            Identify the symptom. Inspect the system. Isolate the fault. Plan the repair. Verify the result.
          </p>

          <BoxImage className="mx-auto mt-2 max-w-[260px] sm:max-w-[320px]" data-id="element-59" data-mp="302lrxh7h7xq4" />

          <p className="mt-2 font-display text-[1.3rem] font-extrabold uppercase leading-none text-white sm:text-[1.75rem]" data-id="element-60" data-mp="300iy0m37dkg4">
            🏊 POOL &amp; SPA <span className="text-aqua" data-id="element-61" data-mp="39son9o22lnrm">DIAGNOSTIC PRO™</span>
          </p>
          <p className="mt-1 font-display text-[0.64rem] font-extrabold uppercase text-white/75 sm:text-[0.8rem]" data-id="element-62" data-mp="3errsb8i1vtzl">
            THE COMPLETE POOL &amp; SPA TROUBLESHOOTING &amp; REPAIR SYSTEM
          </p>
          <p className="mt-0.5 font-display text-[0.6rem] font-extrabold uppercase tracking-[0.06em] text-sun sm:text-[0.76rem]" data-id="element-63" data-mp="1jo3gleqt412g">
            Identify • Inspect • Diagnose • Isolate • Repair • Verify
          </p>

          <div className="mx-auto mt-2 max-w-md" data-id="element-64" data-mp="1sgx05odadmm4">
            <p className="font-display text-[0.8rem] font-extrabold uppercase text-white sm:text-[0.95rem]" data-id="element-65" data-mp="1sirozdrohyvh">
              🔥 GET THE COMPLETE SYSTEM TODAY —{' '}
              <span className="whitespace-nowrap rounded bg-sun px-1.5 text-navy" data-id="element-66" data-mp="22drurw6fv2v4">$27 USD</span>
            </p>
            <div className="mt-1.5" data-id="element-67" data-mp="1xf8b62fbi35x">
              <CTAButton label="🏊 GET POOL & SPA DIAGNOSTIC PRO™" data-id="element-68" data-mp="2bfj2t7ogbls5" />
            </div>
            <p className="mt-2 text-[0.66rem] font-bold uppercase tracking-wide text-white/85 sm:text-xs" data-id="element-69" data-mp="2bdeyiomn4krc">
              Immediate Access • Digital Delivery
            </p>
            <p className="mt-0.5 text-[0.66rem] font-bold uppercase tracking-wide text-white/85 sm:text-xs" data-id="element-70" data-mp="h209yb5d8rd6">
              🛡️ 7-Day Money-Back Guarantee
            </p>
          </div>
        </div>
      </div>
    </section>;
}